import React from 'react';
import Auth from './Auth';

// Kept for backward compatibility: /register still works,
// but renders the unified Auth page with the "Créer un compte" tab.
export default function Register() {
  return <Auth defaultTab="register" />;
}
